// /quienes-somos — SSR head() with Organization JSON-LD
import { createFileRoute } from "@tanstack/react-router";
import AboutUs from "@/pages/AboutUs";
import { buildStaticHead, staticLoader, type StaticSEO } from "@/lib/static-route-seo";

const SEO: StaticSEO = {
  es: {
    title: "Quiénes Somos | Fora da Rota",
    description:
      "Conoce a Fora da Rota: la agencia especializada en viajes auténticos a Brasil. Nuestra historia, misión y equipo.",
  },
  "pt-BR": {
    title: "Quem Somos | Fora da Rota",
    description:
      "Conheça a Fora da Rota: agência especializada em viagens autênticas para o Brasil. Nossa história, missão e equipe.",
  },
  en: {
    title: "About Us | Fora da Rota",
    description:
      "Meet Fora da Rota: the agency specialized in authentic trips to Brazil. Our story, mission and team.",
  },
  "en-EU": {
    title: "About Us | Fora da Rota",
    description:
      "Meet Fora da Rota: the agency specialized in authentic trips to Brazil. Our story, mission and team.",
  },
};

export const Route = createFileRoute("/quienes-somos")({
  loader: staticLoader,
  head: ({ loaderData }) =>
    buildStaticHead(SEO, "/quienes-somos", loaderData, {
      jsonLd: (url, seo) => ({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: seo.title,
        description: seo.description,
        url,
        mainEntity: {
          "@type": "Organization",
          name: "Fora da Rota",
          url: "https://www.foradarota.com",
        },
      }),
    }),
  component: AboutUs,
});
